(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.MEG",
                {
                    url: "/MEG",
                    component: "meg",
                    PageTitle: "Mark Edward Gaffney",
                    requiredPermissions: "MarkGaffney:View"
                });
        }
    ]);

    app.component("meg",
        {
            templateUrl: "App/Resources/MEG/MEG-template.html",
            controller: megController
        });

    megController.$inject = ["eligibilityFormApi", "surveys", "eligibilityFormDialog", "permissionService", "amplitudeService", "$window"];

    function megController(eligibilityFormApi, surveys, eligibilityFormDialog, permissionService, amplitudeService, $window) {

        var $ctrl = this;     
        ng.extend($ctrl,
            {
                dyp12SurveyId: null,
                mdc10SurveyId: null,               
                submittedSurveyId: null               
            });

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {          

            $ctrl.dyp12SurveyId = s.markEdwardGaffneyDYP12Id;
            $ctrl.mdc10SurveyId = s.markEdwardGaffneyMDC10Id;
            eligibilityFormApi.isEnrolled(s.markEdwardGaffneyDYP12Id).then(function (response) {                
                if (response) {
                    $ctrl.submittedSurveyId = s.markEdwardGaffneyDYP12Id;     
                }               
            });

            eligibilityFormApi.isEnrolled(s.markEdwardGaffneyMDC10Id).then(function (response) {             
                if (response) {
                    $ctrl.submittedSurveyId = s.markEdwardGaffneyMDC10Id;    
                }   
            });
        });

        /*  Open the Enrollment Form based on surveyId  */
        $ctrl.openDialog = function (event, surveyId) {
                       
            eligibilityFormDialog.open(event, surveyId).then(function (obj) {
                ng.extend($ctrl, obj);
            });
        };

        $ctrl.openUrl = function (url) {           
            $window.open(url);
        };

    }

})(window.app, window.angular); // jshint ignore:line